var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import { Icon, InlineChildren, StackChildren, Text, Inset, Colors, Stack, } from '@doordash/design-language';
import styled from 'styled-components';
var Container = styled(Inset)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), Colors.SystemYellow5);
export var ModalFormWarning = function (_a) {
    var title = _a.title, description = _a.description;
    return (React.createElement(Stack, { size: Stack.Sizes.Large },
        React.createElement(Container, null,
            React.createElement(InlineChildren, { size: InlineChildren.Sizes.Small },
                React.createElement(Icon, { color: Icon.Colors.BannerWarningIcon, type: Icon.Types.WarningFill }),
                React.createElement(StackChildren, { size: StackChildren.Sizes.XxxSmall },
                    React.createElement(Text, { styles: Text.Styles.BannerLabel }, title),
                    React.createElement(Text, { styles: Text.Styles.Body1 }, description))))));
};
export default ModalFormWarning;
var templateObject_1;
